import {Loader2, MoveLeft, X} from "lucide-react";
import { useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import paymentStore from "../store/paymentStore.ts";
import Animation from "../components/Animation.tsx";
import usePaymentListener from "../hooks/usePaymentListener.ts";

const Gateway = () => {
    const paymentData = paymentStore.getState().paymentData
    const paymentUrl  = paymentData?.paymentUrl
    const  voucherRequestId   = paymentData?.voucherRequestId
    const [isLoading, setIsLoading] = useState(true);
    const { state } = useLocation();
    const quantity = state?.quantity;

    /*const handleLoad = () => {
        setIsLoading(false);
    };*/

    const [status, setStatus] = useState<'success' | 'error'>('error');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const navigate = useNavigate();

    const closeModal = () => {
        setIsModalOpen(false);
        navigate(-1)
    };

    const { response, startBackgroundCalls, stopBackgroundCalls } = usePaymentListener(voucherRequestId)

    useEffect(() => {
        startBackgroundCalls();

        return () => {
            setIsModalOpen(false);
            setIsLoading(true);
        }
    }, []);

    useEffect(() => {
        if (response?.success) {
            if(response?.data?.length === quantity) {
                stopBackgroundCalls();
                setStatus('success');
                setIsModalOpen(true);
            }
        } else {
            if(response?.status === 8) {
                setStatus('error');
                setIsModalOpen(true);
            }
        }
    }, [response]);

    return (
        <div
            style={{
                backgroundImage: `url('/pattern-14.png')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            className="min-h-screen"
        >
            <div className='p-2'>
                <div className="rounded-full w-12 h-12 bg-primary flex items-center justify-center">
                    <button
                        onClick={() =>  navigate(-1)}
                    >
                        <MoveLeft color="#fff" className="w-6 h-6 "/>
                    </button>
                </div>
            </div>
            {isLoading && (
                <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center bg-gray-50">
                    <div><Loader2 className="w-12 h-12 text-blue-500 animate-spin" /></div>
                    <p className="ml-2 text-gray-600">Chargement de la page de paiement ...</p>
                </div>
            )}

            {/* Main Content */}
            <div className="w-full">
                {!isModalOpen && <div className="w-full h-screen">
                    <iframe
                        src={paymentUrl}
                        className="w-full h-full border-0"
                        allowFullScreen
                        title="Embedded Page"
                        onLoad={() => setIsLoading(false)}
                    />
                </div>}
                {isModalOpen && (
                    <div className="fixed isnset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                        <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-bold">Opération Terminée</h2>
                                <button
                                    onClick={()=> {
                                        navigate(-1)
                                        closeModal()
                                    }}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <X size={30}/>
                                </button>
                            </div>
                            <div className="flex items-center justify-center p-6">

                                <Animation type={status}/>
                            </div>
                            <p className="text-gray-600">{status === 'success' ? 'Votre requête a été traitée avec succès.' : 'Une erreur est survnue  lors du traitement de votre requête'}</p>
                            <div className="mt-4 flex justify-center flex flex-row   items-center">
                                {
                                    status === 'success' ? <>
                                        <button
                                            onClick={() => {
                                                //closeModal();
                                                navigate('/billet', {
                                                    state: {
                                                        vouchers: response?.data
                                                    }
                                                });
                                            }}
                                            className="px-4 py-2 bg-[#9DBE42]  text-white rounded-full hover:bg-[#9DBE42]"
                                        >
                                            Voir mes billet
                                        </button>
                                    </> : <button
                                        onClick={() => {
                                            closeModal();
                                            navigate(-1)
                                        }}
                                        className="px-4 py-2 bg-gray-500 text-white rounded-full hover:bg-[#9DBE42]"
                                    >
                                        Retour
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default Gateway;
